import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import AwaitingIcon from '../../components/icons/Awaiting';
import Price from '../../components/Price';

const PaymentAwaiting = ({amount}) => {
  const {t} = useTranslation(['common', 'order']);

  return (
    <>
      <div className="payment-status">
        <AwaitingIcon className="payment-status-success"/>
      </div>

      <div className="payment-status">
        <p className="payment-status-message">{t('order:payment.awaiting', {amount: Price.Text({value: amount})})}</p>
      </div>
    </>
  );
};

PaymentAwaiting.propTypes = {
  amount: PropTypes.number,
};

export default PaymentAwaiting;